import BaseObject from './BaseObject.js';
import PrimaryMenuItem from './PrimaryMenuItem.js';

export default class MenuItem extends BaseObject {
  constructor() {
    super();
    this.children = [];
  }

  get hasChildren() {
    return (this.children || []).length > 0;
  }

  get routes() {
    const routes = [];
    if (this.hasChildren) {
      this.children.forEach((primaryElement) => {
        const primaryRoute = primaryElement.route;
        if (primaryRoute !== null) routes.push(primaryRoute);
        if (primaryElement.hasChildren) {
          primaryElement.children.forEach((secondaryElement) => {
            const secondaryRoute = secondaryElement.route;
            if (secondaryRoute !== null) routes.push(secondaryRoute);
            if (secondaryElement.hasChildren) {
              secondaryElement.children.forEach((tertiaryElement) => {
                const tertiaryRoute = tertiaryElement.route;
                if (tertiaryRoute !== null) routes.push(tertiaryRoute);
              });
            }
          });
        }
      });
    }
    return routes;
  }

  RegisterChild(primary) {
    if (primary instanceof PrimaryMenuItem) {
      this.children.push(primary);
    }
  }

  /**
 * 取得可用 Menu
 * @param {Array} features
 * @param {MenuItem} menuItem
 */
  static GetEnabledFeatures(features, menuItem) {
    const result = [];
    if (menuItem.hasChildren) {
      menuItem.children.forEach((primaryMenu) => {
        // 第一層選單
        const primaryElement = features.filter((item) => item.id === primaryMenu.id)[0];
        if (primaryElement) {
          // 有權限的第一層選單
          const newPrimaryFeature = { ...primaryElement };
          newPrimaryFeature.children = [];
          if (primaryMenu.hasChildren) {
            primaryMenu.children.forEach((secondaryMenu) => {
            // 第二層選單
              const secondaryElement = (primaryElement.children || []).filter((item) => item.id === secondaryMenu.id)[0];
              if (secondaryElement) {
                // 有權限的第二層選單
                const newSecondaryFeature = { ...secondaryElement };
                newSecondaryFeature.children = [];
                if (secondaryMenu.hasChildren) {
                  secondaryMenu.children.forEach((tertiaryMenu) => {
                    // 第三層選單
                    const tertiaryElement = (secondaryElement.children || []).filter((item) => item.id === tertiaryMenu.id)[0];
                    if (tertiaryElement) {
                      // 有權限的第三層選單
                      const newTertiaryFeature = { ...tertiaryElement };

                      newSecondaryFeature.children.push(newTertiaryFeature);
                    }
                  });
                } else {
                  newSecondaryFeature.children = secondaryElement.children || [];
                }

                newPrimaryFeature.children.push(newSecondaryFeature);
              }
            });
          } else {
            newPrimaryFeature.children = primaryElement.children || [];
          }

          result.push(newPrimaryFeature);
        }
      });
    }
    return result;
  }

  /**
 * 取得可用 Menu
 * @param {Array} features
 * @param {MenuItem} menuItem
 */
  static GetEnabledMenuItem(features, menuItem) {
    const result = new MenuItem();
    if (menuItem.hasChildren) {
      menuItem.children.forEach((primaryMenu) => {
        // 第一層選單
        const primaryElement = features.filter((item) => item.id === primaryMenu.id)[0];
        if (primaryElement) {
          // 有權限的第一層選單
          const newPrimaryMenu = primaryMenu.Clone();
          newPrimaryMenu.ClearChildren();
          if (primaryMenu.hasChildren) {
            primaryMenu.children.forEach((secondaryMenu) => {
              // 第二層選單
              const secondaryElement = (primaryElement.children || []).filter((item) => item.id === secondaryMenu.id)[0];
              if (secondaryElement) {
                // 有權限的第二層選單
                const newSecondaryMenu = secondaryMenu.Clone();
                newSecondaryMenu.ClearChildren();
                if (secondaryMenu.hasChildren) {
                  secondaryMenu.children.forEach((tertiaryMenu) => {
                    // 第三層選單
                    const tertiaryElement = (secondaryElement.children || []).filter((item) => item.id === tertiaryMenu.id)[0];
                    if (tertiaryElement) {
                      // 有權限的第三層選單
                      const newTertiaryMenu = tertiaryMenu.Clone();
                      newTertiaryMenu.ClearChildren();
                      newTertiaryMenu.features = tertiaryElement.children || [];
                      if (newTertiaryMenu.component) {
                        newTertiaryMenu.Navigate = { name: newTertiaryMenu.id };
                      }
                      newSecondaryMenu.RegisterChild(newTertiaryMenu);
                    }
                  });
                } else {
                  newSecondaryMenu.features = secondaryElement.children || [];
                }
                // 導航處理
                if (newSecondaryMenu.component) {
                  newSecondaryMenu.Navigate = { name: newSecondaryMenu.id };
                }

                if (newSecondaryMenu.hasChildren) {
                  const navChild = newSecondaryMenu.children.filter((item) => item.component)[0];
                  if (navChild) {
                    newSecondaryMenu.Navigate = { name: navChild.id };
                  }
                }

                newPrimaryMenu.RegisterChild(newSecondaryMenu);
              }
            });
          } else {
            newPrimaryMenu.features = primaryElement.children || [];
          }

          if (newPrimaryMenu.component) {
            newPrimaryMenu.Navigate = { name: newPrimaryMenu.id };
          }
          result.RegisterChild(newPrimaryMenu);
        }
      });
    }
    return result;
  }
}
